import React from "react";
import { Field } from "@design-system/Field/Field";
import { Input } from "@design-system/Input/Input";
import styles from "./SidePanel.module.scss";

interface Props {
    name: string;
    error?: string;
    onNameChange: (name: string) => void;
    inputRef?: React.Ref<HTMLInputElement>;
}

export const TemplateNamePanel: React.FC<Props> = ({
    name,
    error,
    onNameChange,
    inputRef,
}) => (
    <div className={styles.templateGroup}>
        <div className={styles.cardTitle}>Template name</div>
        <Field.Root invalid={Boolean(error)}>
            <Input
                ref={inputRef}
                aria-label="Template name"
                size="xl"
                maxLength={255}
                value={name}
                invalid={Boolean(error)}
                onFocus={(event) => event.currentTarget.select()}
                onChange={(event) => onNameChange(event.target.value)}
            />
        </Field.Root>
    </div>
);
